module.exports = "/_next/static/images/gn-7de807363eb98f680e0e3ed25d48543f.svg";